<template>
  <body id="app">

    <router-view name="header" />

    <router-view />

    <Loading
      v-model:active="isLoading"
      :is-full-page="true"
      loader="spinner"
    />

    <router-view name="bot" />

    <router-view name="footer" />

  </body>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

export default {
  name: 'App',
  components: {
    Loading
  },
  computed: {
    isLoading: {
      get () {
        return this.$store.state.isLoading
      },
      set (value) {
        if (value) {
          this.$store.commit('showLoading')
        } else {
          this.$store.commit('hideLoading')
        }
      }
    },
    backgroundColor () {
      return {
        backgroundColor: '#FFFFFF'
      }
    }
  }
}
</script>
<style>
/* 修正 a tag 不存在 href 屬性時滑鼠指標 */
.pointer {
  cursor: pointer;
}

/* vue-loading-overlay v6 使用 vl- prefix */
.vl-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 1
}

.vl-overlay.is-active {
  display: flex
}

.vl-overlay.is-full-page {
  z-index: 999;
  position: fixed
}

.vl-overlay .vl-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5
}

.vl-overlay .vl-icon, .vl-parent {
  position: relative
}
</style>
